import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const items = [
  "Niños, adolescentes y adultos",
  "Métodos: ABA, TEACCH, Dember y más",
  "Arequipa, Perú",
  "Equipo multidisciplinario certificado",
];

export default function TrustStrip() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <section
      id="franja"
      ref={ref}
      aria-label="Características del centro"
      className="bg-navy py-5 overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.5 }}
        className="max-w-7xl mx-auto px-5 sm:px-8"
      >
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {items.map((item, i) => (
            <li
              key={item}
              className="flex items-center gap-3 font-sans text-sm font-medium text-white/90"
            >
              {i > 0 && (
                <span
                  className="hidden sm:block w-1 h-1 rounded-full bg-white/30 flex-shrink-0"
                  aria-hidden="true"
                />
              )}
              <span className="w-1.5 h-1.5 rounded-full bg-sage flex-shrink-0 sm:hidden" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      </motion.div>
    </section>
  );
}
